import {appStore} from "../store/AppModule";
import { Component, Vue} from "vue-property-decorator";
import http from "../services/Http";
import { CheckoutTranslationModel as TranslationModel } from "../models/deliveryModel";
import { VoucherCodeResult } from "../models/common";
import { EventBus } from "../events";


@Component
export default class VoucherCampaign extends Vue {
    protected translations: TranslationModel;
    private labelText: string = "";
    private buttonText: string = "";
    private voucherCode: string = "";
    private voucherCodeResult: string = "";

    private url: string = window.location.origin + window.location.pathname;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected created() {
         this.labelText =  this.$attrs.labeltext;
         this.buttonText =  this.$attrs.buttontext;
    }
    protected applyCampaignCode() {
        const request = {
            campaignCode: this.voucherCode
        };
        http.post<VoucherCodeResult>(`${this.url}.setCampaignCode`, request)
        .then(r => {
            this.voucherCodeResult = r.message;
            if (r.success) {
                EventBus.$emit("refreshCartSummary");
                EventBus.$emit("refreshDeliverySelector");
            }
        });
    }
}
